import { SalesApi } from '../api/sales.api';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from './store';
import type { BusinessSales } from '@recargas-dominicanas/core/types';
import { currentMonthStart, now } from '@recargas-dominicanas/core/utils';

type SalesState = BusinessSales & {
  loading: boolean;
  failed: boolean;
};

export const salesSlice = createSlice({
  name: 'sales',
  initialState: {
    loading: true,
    failed: false,
    balance: 0,
    sales: 0,
    profit: 0,
    count: 0,
    transactions: [],
    transactionsByProduct: []
  } as SalesState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setFailed(state, action: PayloadAction<boolean>) {
      state.failed = action.payload;
    },
    setData(state, action: PayloadAction<BusinessSales>) {
      return { ...state, ...action.payload };
    }
  }
});

export function useSalesStore() {

  const dispatch = useAppDispatch();
  const state = useAppSelector(state => state.sales);

  async function fetch(start: Date = currentMonthStart(), end: Date = now(), period: 'day' | 'month' = 'day') {

    try {

      dispatch(salesSlice.actions.setLoading(true));
      dispatch(salesSlice.actions.setFailed(false));

      const salesData = await SalesApi.getSales({
        startDate: start.toISOString(),
        endDate: end.toISOString(),
        period
      });

      dispatch(salesSlice.actions.setData(salesData));
      dispatch(salesSlice.actions.setLoading(false));

    } catch (err) {

      console.error(err);
      dispatch(salesSlice.actions.setLoading(false));
      dispatch(salesSlice.actions.setFailed(true));

    }
  }

  async function fetchBalance() {

    try {

      const balance = await SalesApi.getBalance();
      dispatch(salesSlice.actions.setData({ ...state, balance: balance.amount }));

    } catch (err) {

      console.error(err);

    }
  }

  return {
    ...state,
    fetch,
    fetchBalance
  };
}
